import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import { Loading } from '@gpstrackit/gtc-react-controls';

// Widgets
import CoachingEducationWidget from './widgets/coachingEducation';
import PerformanceImprovementWidget from './widgets/performanceImprovement';
import InterventionWidget from './widgets/intervention';
import EscalationWidget from './widgets/escalation';

// Redux
import { searchDriverCaseAccountConfigs } from './redux/slice';

// Styles
import './index.scss';

// Widget mapping
const WIDGET_COMPONENTS = {
    'functions_coachingEducation': CoachingEducationWidget,
    'functions_escalation': EscalationWidget,
    'functions_performanceImprovement': PerformanceImprovementWidget,
    'functions_intervention': InterventionWidget
};

// Default widget configs with correct order
const DEFAULT_WIDGETS = [
    { id: 'default_1', configType: 'functions_coachingEducation', autoCurate: null },
    { id: 'default_2', configType: 'functions_performanceImprovement', autoCurate: null },
    { id: 'default_3', configType: 'functions_escalation', autoCurate: null },
    { id: 'default_4', configType: 'functions_intervention', autoCurate: null }
];

const FunctionTab = () => {
    const dispatch = useDispatch();
    const { configs, loadingConfigs } = useSelector(state => state.driverPerformanceFunctionTabRedux || {});

    // Merge API configs with defaults
    const getWidgetConfigs = () => {
        return DEFAULT_WIDGETS.map(defaultWidget => {
            const apiConfig = configs?.find(config => config.configType === defaultWidget.configType);
            return apiConfig || defaultWidget;
        });
    };

    useEffect(() => {
        dispatch(searchDriverCaseAccountConfigs());
    }, [dispatch]);

    if (loadingConfigs) {
        return <Loading overlay show />;
    }

    const widgetConfigs = getWidgetConfigs();

    return (
        <div className="function-tab-container">
            <div className="widgets-grid">
                {widgetConfigs.map((config, index) => {
                    const WidgetComponent = WIDGET_COMPONENTS[config.configType];

                    if (!WidgetComponent) return null;

                    return (
                        <div key={config.configType} className={`widget-item widget-${index + 1}`}>
                            <WidgetComponent configData={config} allConfigs={configs} />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default FunctionTab;
